import { LOCAL_STORAGE_KEYS } from '@/lib/consts/localStorage';
import { LOGIN_QUERY_PARAMS } from '@/lib/consts/params';
import { createSingleUseLoginGuard } from './singleUseLoginGuard';

const portalRedirectGuard = createSingleUseLoginGuard({
    scope: 'local',
    storageKey: LOCAL_STORAGE_KEYS.PORTAL_REDIRECT_LOGIN_ATTEMPTED,
    urlParams: [
        LOGIN_QUERY_PARAMS.REDIRECT_LOGIN_TOKEN,
        LOGIN_QUERY_PARAMS.JOURNEY_ID,
    ],
});

/**
 * Marks a portal handoff token as already exchanged by auto-login.
 * Keyed by token so the next portal handoff still logs the player in.
 */
export const markPortalRedirectLoginAttempted = (token: string): void => {
    portalRedirectGuard.markAttempted(token);
};

export const isPortalRedirectLoginAttempted = (token: string): boolean =>
    portalRedirectGuard.isAttempted(token);

/**
 * Strip the handoff token immediately so a reload or a back navigation no longer
 * looks like a fresh portal redirect (`getRedirectFromPortalLoginToken()`
 * becomes null).
 */
export const clearPortalRedirectLoginParamsFromUrl = (): void => {
    portalRedirectGuard.clearParamsFromUrl();
};
